export default (() => {
  document.addEventListener('facetwp-refresh', function () {
    const spinner = document.querySelector('.dynamic-search .spinner')
    if (spinner) spinner.classList.add('active')

  });

  document.addEventListener('facetwp-loaded', function () {
    const spinner = document.querySelector('.dynamic-search .spinner')
    if (spinner) spinner.classList.remove('active')
  });
})()


// WEBPACK FOOTER //
// ./scripts/layout/facetwp.js